import { createTheme } from "@mui/material";

const theme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#3DDAD0",
      contrastText: "white",
    },
    background: {
      paper: "#222222",
    },
  },
});

export default theme;
